module.exports = __webpack_public_path__ + "static/media/sucessGif.7e467a65.gif";